import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const ActivityTemplatesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `ActivityPlan/GetActivityTemplateById/${props.activityTemplateId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `ActivityPlan/SaveActivityPlanTemplate`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'edit', url: `ActivityPlan/SaveActivityPlanTemplate`, method: 'POST', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `ActivityPlan/GetActivityTemplatesByPlanId/${props.activityPlanId}?start=0&length=10000`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `ActivityPlan/DeleteActivityTemplate/${props.activityTemplateId}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const duplicateRecord = useCallback(async (props) => {
        await execute({ scope: 'dupe', url: `ActivityPlan/DuplicateActivityTemplate/${props.activityTemplateId}`, payload: props, method: 'POST', secure: true });
    }, [execute]);  

    const listBusinessDayTypes = useCallback(async (props) => {
        await execute({ scope: 'list_businessdaytypes', url: `ActivityPlan/BusinessDayTypes`, method: 'GET', secure: true });
    }, [execute]);  

    const listOperators = useCallback(async (props) => {
        await execute({ scope: 'list_operators', url: `ActivityPlan/Operators`, method: 'GET', secure: true });
    }, [execute]);  

    const listTriggeringFields = useCallback(async (props) => {
        await execute({ scope: 'list_triggeringfields', url: `ActivityPlan/TriggeringFieldsList/${props.categoryId}`, method: 'GET', secure: true });
    }, [execute]);
    
    const listTriggeringImmediateFields = useCallback(async (props) => {
        await execute({ scope: 'list_triggeringimmediatefields', url: `ActivityPlan/TriggeringImmediateFieldsList/${props.categoryId}`, method: 'GET', secure: true });
    }, [execute]);
    
    const listFileCompleteStatuses = useCallback(async(props) => {
        await execute({ scope: 'list_filecompletestatuses', url: `ActivityPlan/FileCompleteStatuses`, method: 'GET', secure: true });
    }, [execute]);

    const listSettlementStatementStatuses = useCallback(async(props) => {
        await execute({ scope: 'list_settlementStatementStatuses', url: 'ActivityPlan/SettlementStatementStatuses', method: 'GET', secure: true });
    })

    const listTransactionStatusTriggers = useCallback(async(props) => {
        await execute({ scope: 'list_transactionstatustriggers', url: `ActivityPlan/TransactionStatusTriggers/${props.categoryId}`, method: 'GET', secure: true });
    }, [execute]);

    const listAgentStatusTriggers = useCallback(async(props) => {
        await execute({ scope: 'list_agentstatustriggers', url: `ActivityPlan/AgentStatusTriggers`, method: 'GET', secure: true });
    }, [execute]);

    const listPrecedingActivities = useCallback(async (props) => {
        await execute({ scope: 'list_precedingactivities', url: `ActivityPlan/PrecedingActivities/${props.templateId}/${props.planId}`, method: 'GET', secure: true });
    }, [execute]);  

    const listSecurityRoles = useCallback(async(props) => {
        await execute({ scope: 'list_securityroles', url: `ActivityPlan/AssignToSecurityRoles`, method: 'GET', secure: true });
    }, [execute]);

    const listDepartmentEmailActivityTargets = useCallback(async(props) => {
        await execute({ scope: 'list_departmentemailactivitytargets', url: `ActivityPlan/DepartmentEmailActivityTargets`, method: 'GET', secure: true });
    }, [execute]);

    const listInstanceTypes = useCallback(async(props) => {
        await execute({ scope: 'list_instancetypes', url: `ActivityPlan/InstanceTypes`, method: 'GET', secure: true });
    }, [execute]);

    const listSeverReasons = useCallback(async(props) => {
        await execute({ scope: 'list_severreasons', url: `ActivityPlan/SeverReasons`, method: 'GET', secure: true });
    }, [execute]);
    
    const listActivityTargets = useCallback(async(props) => {
        await execute({ scope: 'list_activitytargets', url: `ActivityPlan/ActivityTargets`, method: 'GET', secure: true });
    }, [execute]);

    const listActivityAgentTypeTargets = useCallback(async(props) => {
        await execute({ scope: 'list_activityagenttypetargets', url: `ActivityPlan/ActivityAgentTypeTargets`, method: 'GET', secure: true });
    }, [execute]);

    const listVendorActivityTargets = useCallback(async(props) => {
        await execute({ scope: 'list_vendoractivitytargets', url: `ActivityPlan/VendorActivityTargets`, method: 'GET', secure: true });
    }, [execute]);

    const listLetterTemplates = useCallback(async (props) => {
        await execute({ scope: 'list_lettertemplates', url: `ActivityPlan/LetterTemplates/${props.categoryId}`, method: 'GET', secure: true });
    }, [execute]);  

    const listEmailTemplates = useCallback(async (props) => {
        await execute({ scope: 'list_emailtemplates', url: `ActivityPlan/EmailTemplates/${props.categoryId}`, method: 'GET', secure: true });
    }, [execute]);  

    const listSmsTemplates = useCallback(async (props) => {
        await execute({ scope: 'list_smstemplates', url: `ActivityPlan/SmsTemplates/${props.categoryId}`, method: 'GET', secure: true });
    }, [execute]);  

    const value = {  listRecords, newRecord, createRecord, selectRecord, duplicateRecord, updateRecord, deleteRecord, data, clearData, 
        listBusinessDayTypes, listOperators, listTriggeringFields, listTriggeringImmediateFields, listFileCompleteStatuses, listSettlementStatementStatuses, listTransactionStatusTriggers,
        listAgentStatusTriggers, listPrecedingActivities, listSecurityRoles, listSeverReasons, listActivityTargets,
        listActivityAgentTypeTargets, listVendorActivityTargets, listLetterTemplates, listEmailTemplates, listSmsTemplates, listInstanceTypes, listDepartmentEmailActivityTargets };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useActivityTemplateStore = () => React.useContext(Context);